import {
  MARYLAND_LOCALITY_OPTIONS,
  type MarylandLocalityCode,
} from '@perdiem/trpc/maryland-local-tax';
import { Select, type SelectOption } from './Select';

const OPTIONS: SelectOption[] = MARYLAND_LOCALITY_OPTIONS.map((option) => ({
  value: option.value,
  label: option.label,
}));

interface MarylandLocalitySelectProps {
  value: string;
  onChange: (value: MarylandLocalityCode) => void;
}

export function MarylandLocalitySelect({
  value,
  onChange,
}: MarylandLocalitySelectProps) {
  return (
    <Select
      value={value || null}
      options={OPTIONS}
      onChange={(next) => onChange(next as MarylandLocalityCode)}
      placeholder="Select Maryland county or Baltimore City…"
      modalTitle="Select Maryland Locality"
    />
  );
}
